import { CoreMenu } from '@core/types';
import { Role } from 'app/auth/models';

//? DOC: http://localhost:7777/demo/vuexy-angular-admin-dashboard-template/documentation/guide/development/navigation-menus.html#interface

export const menu: CoreMenu[] = [


  // Dashboard
  {
    id: 'apps',
    type: 'section',
    title: 'Dashboard',
    translate: 'MENU.APPS.SECTION',
    icon: 'package',
    children: [
      {
        id: 'analytics',
        title: 'Analytics',
        translate: 'MENU.DASHBOARD.ANALYTICS',
        type: 'item',
        icon: 'activity',
        url: '/dashboard/analytics',
        role: [Role.Admin]
      },
      {
        id: 'page-inventory',
        title: 'All Pages',
        type: 'item',
        icon: 'grid',
        url: '/dashboard/page-inventory',
        role: [Role.Admin]
      },
      {
        id: 'knowledge-base',
        title: 'Knowledge Base',
        translate: 'MENU.PAGES.KB',
        type: 'item',
        icon: 'help-circle',
        url: '/pages/knowledge-base',
        role: [Role.Admin]
      },
      {
        id: 'users',
        title: 'User',
        translate: 'MENU.APPS.USER.COLLAPSIBLE',
        type: 'item',
        icon: 'user',
        url: '/apps/user/user-list'
      },

      {
        id: 'Setting',
        title: 'Setting',
        translate: 'MENU.APPS.SETTING',
        type: 'item',
        icon: 'settings',
        url: '/pages/account-settings'
      }

    ]
  },


];
